<template>
    <template v-if="loading">
        <spinner class="mt-2" />
    </template>
    <template v-else-if="guest">
        <layout-guest></layout-guest>
    </template>
    <template v-else-if="admin">
        <layout-admin></layout-admin>
    </template>
    <template v-else>
        <layout></layout>
    </template>
    <alert></alert>
</template>
<script>
import Layout from '../layouts/layout.vue';
import LayoutGuest from '../layouts/layout-guest.vue';
import LayoutAdmin from '../layouts/layout-admin.vue';

export default {
    data() {
        return {
            loading: true,
            guest: true,
            admin: false,
        }
    },

    beforeRouteEnter (to, from) {
        // Initial settings
        if (to.meta.guest !== undefined && to.meta.guest) {
            return (vm) => {
                vm.guest = true;
                vm.admin = false;
                vm.loading = false;
            }
        } else if (to.meta.admin !== undefined && to.meta.admin) {
            return (vm) => {
                vm.guest = false;
                vm.admin = true;
                vm.loading = false;
            }
        } else {
            return (vm) => {
                vm.guest = false;
                vm.admin = false;
                vm.loading = false;
            }
        }
    },
    components: {
        Layout,
        LayoutGuest,
        LayoutAdmin
    }
}
</script>

